module.exports = __webpack_public_path__ + "static/media/BharatTube.3d6bdc92.png";